import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { CampanhaCountLabelPipe } from './campanha-count-label.pipe';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CampanhaCountLabelPipe
    ],
    exports: [
        CampanhaCountLabelPipe
    ],
    providers: [
        CampanhaCountLabelPipe
    ]
})
export class CampanhaPipeModule { }
